import { Button, Divider, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import './ConfirmationEmailModal.less';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { activateEmailConfirmation, fetchMeUserFull } from '../../store/slices/personsSlice/personsSlice';
import { uniqueId } from 'lodash';
import { checkIsError, checkIsLoaded, checkIsLoading } from '../../lib/utils/checkLoadingStatus';

interface MessageData {
  text: string;
}

const ConfirmationEmailModal = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { meUser } = useAppSelector((state) => state.persons);
  const { activateEmailConfirmationLoading, activateEmailConfirmationData } = useAppSelector((state) => state.persons);

  const [messageData, setMessageData] = useState<MessageData>({
    text: '',
  });

  const confirmEmail = () => {
    if (!location.pathname.includes('/email-confirmation')) return;
    if (!location.search) return;

    const token = new URLSearchParams(location.search).get('Token');

    if (!token) return;

    dispatch(
      activateEmailConfirmation({
        token,
        onSucces: () => {
          if (meUser && meUser.id) {
            dispatch(fetchMeUserFull({ personId: meUser.id }));
          }
        },
      })
    );
  };

  useEffect(() => {
    if (activateEmailConfirmationLoading === 'idle') {
      confirmEmail();
    }
  }, [location.search, activateEmailConfirmationLoading, dispatch]);

  const navigate = useNavigate();
  return (
    <Spin spinning={checkIsLoading(activateEmailConfirmationLoading)}>
      <div className="email-confirmation-container">
        <div className="email-confirmation-innerContainer">
          <div className="logo mb15" />
          {checkIsLoaded(activateEmailConfirmationLoading) && (
            <>
              <h2 className="email-confirmation-title">Почтовый адрес подтвержден</h2>
              <Divider />
              <div className="font-roboto text-left" style={{ display: 'flex', justifyContent: 'center' }}>
                Спасибо! указанный адрес электронной почты подтверждён.
              </div>
            </>
          )}

          {checkIsError(activateEmailConfirmationLoading) && (
            <>
              <h2 className="email-confirmation-title">Ошибка подтверждения почты</h2>
              <Divider />
              <div className="font-roboto text-left ml5">
                Не удалось подтвердить почтовый адрес. <br />
                {activateEmailConfirmationData?.split('.').map((item) => (
                  <div key={uniqueId()}>
                    {item} <br />
                  </div>
                ))}
                Запросите подтверждение почты еще раз.
              </div>
            </>
          )}

          <div className="email-confirmation-buttons">
            <Button
              type="primary"
              htmlType="submit"
              className="email-confirmation-submitBtn"
              disabled={checkIsLoading(activateEmailConfirmationLoading)}
              onClick={() => {
                navigate('/profile');
              }}
            >
              Закрыть
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ConfirmationEmailModal;
